import React, { ButtonHTMLAttributes, forwardRef } from 'react'
import classes from './button.module.scss'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: 'light' | 'dark'
  variant?: 'default' | 'primary' | 'outline' | 'primaryOutline'
  size?: 'medium' | 'large'
  inProgress?: boolean
  children: any
}

const Button = forwardRef<HTMLButtonElement, Props>((props: Props, ref) => {
  const {
    theme = 'light',
    variant = 'default',
    size = 'medium',
    inProgress = false,
    children,
    ...rest
  } = props

  return (
    <button
      className={`${classes.button} ${classes[theme]} ${classes[size]} ${classes[variant]}`}
      ref={ref}
      {...rest}>
      {children}
      {inProgress && <div className={classes.progress}></div>}
    </button>
  )
})

export default Button
